export const contactsData = {
    email: 'shadrackipruto@gmail.com',
    phones: [
        '+254 727 221 023',
        '+353 899 711 336',
    ],
    address: 'Nairobi, Kenya',
    website: 'https://shadrackipruto.vercel.app',
    sheetAPI: ''
};
